import { Component, input } from '@angular/core';
import { LazyLoadTable } from '@assethub/shared/utils/lazy-load-table';
import { CalloutComponent } from '../callout/callout.component';

@Component({
  selector: 'app-lazy-load-table-messages',
  templateUrl: './lazy-load-table-messages.component.html',
  styleUrls: ['./lazy-load-table-messages.component.scss'],
  imports: [CalloutComponent],
})
export class LazyLoadTableMessagesComponent<T> {
  readonly listContext = input.required<LazyLoadTable<T>>();
  readonly noDataMsg = input.required<string>();
  readonly nofilteredDataMsg = input.required<string>();
  readonly errorMsg = input<string>();
}
